import { NextSeo } from 'next-seo';
import Head from 'next/head';
import {
  CLEARTAX_DOMAIN,
  FAVICON_IMG,
  SEO_CONFIG,
} from '../../config/constants';

type IMetaProps = {
  title?: string;
  description?: string;
  canonical?: string;
  ogimage?: string;
  keywords?: string;
  noindex?: boolean;
};

const Meta: React.FC<IMetaProps> = ({
  title = SEO_CONFIG.title,
  description = SEO_CONFIG.description,
  canonical = '/checkout',
  noindex = false,
  ogimage = '',
  keywords,
}) => {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" key="charset" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1"
          key="viewport"
        />
        <link rel="shortcut icon" href={FAVICON_IMG} type="image/png" />
        <link rel="apple-touch-icon" href={FAVICON_IMG} />
        <link rel="apple-touch-icon" sizes="57x57" href={FAVICON_IMG} />
        <link rel="apple-touch-icon" sizes="72x72" href={FAVICON_IMG} />
        <link rel="apple-touch-icon" sizes="76x76" href={FAVICON_IMG} />
        <link rel="apple-touch-icon" sizes="114x114" href={FAVICON_IMG} />
        <link rel="apple-touch-icon" sizes="120x120" href={FAVICON_IMG} />
        <link rel="apple-touch-icon" sizes="144x144" href={FAVICON_IMG} />
        <link rel="apple-touch-icon" sizes="152x152" href={FAVICON_IMG} />
        <link rel="shortcut icon" href={FAVICON_IMG} type="image/x-icon" />
        <link rel="dns-prefetch" href="https://assets1.cleartax-cdn.com" />
        {keywords ? <meta property="keywords" content={keywords} /> : null}
      </Head>
      <NextSeo
        title={title}
        description={description}
        canonical={`${CLEARTAX_DOMAIN}${canonical}`}
        openGraph={{
          title: title,
          description: description,
          url: `${CLEARTAX_DOMAIN}${canonical}`,
          locale: SEO_CONFIG.locale,
          site_name: SEO_CONFIG.site_name,
          ...(ogimage
            ? {
                images: [
                  {
                    url: ogimage,
                  },
                ],
              }
            : {}),
        }}
        {...(noindex ? { noindex: noindex } : {})}
      />
    </>
  );
};

export { Meta };
